import React from 'react';

const LOGO = 'https://customer-assets-4nw71qhi.emergentagent.net/job_image-to-site-34/artifacts/x66zayl8_1000002735.jpeg';
const PRODUCT_PHOTO = 'https://customer-assets-4nw71qhi.emergentagent.net/job_image-to-site-34/artifacts/go1vr5tt_1000002737.jpeg';

const ToucheCollab = () => {
  return (
    <section id="touche-collab" data-testid="touche-collab-section" className="bg-[#1b2a41] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-[#C9A96A] uppercase tracking-[0.3em] text-sm mb-3" data-testid="touche-collab-label">
            Exclusive Collaboration
          </p>
          <h2 className="text-white font-serif text-3xl sm:text-4xl" data-testid="touche-collab-title">
            The Bow Tie Guy &times; Touche Cosmetics
          </h2>
          <p className="text-[#C9A96A] italic text-lg md:text-xl mt-4" data-testid="touche-collab-slogan">
            &ldquo;Feel good, look good and smell good.&rdquo;
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="overflow-hidden rounded-sm">
            <img
              src={PRODUCT_PHOTO}
              alt="Touche Cosmetics luxury face, body, beard and hair oils"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
              data-testid="touche-collab-photo"
            />
          </div>
          <div className="text-center md:text-left">
            <a href="https://www.touchecosmetic.com/" target="_blank" rel="noopener noreferrer" data-testid="touche-logo-link">
              <img
                src={LOGO}
                alt="Touche Cosmetics - Luxury at it's finest"
                loading="lazy"
                decoding="async"
                className="w-56 mx-auto md:mx-0 mb-6 rounded-sm hover:opacity-90 transition-opacity"
                data-testid="touche-collab-logo"
              />
            </a>
            <p className="text-gray-300 leading-relaxed mb-4">
              We&apos;ve partnered with Touche Cosmetics to complete your look from head to toe.
              Their handcrafted face &amp; body oils and beard/hair oils are luxury at it&apos;s
              finest — the perfect companion to your favorite bow tie.
            </p>
            <p className="text-gray-300 leading-relaxed mb-8">
              Signature scents include Rosehip Jasmine, Oakmoss &amp; Amber, and more.
              Ask about Touche Cosmetics with your next order.
            </p>
            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
              <a
                href="https://www.touchecosmetic.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="touche-collab-shop-btn"
                className="inline-block bg-[#C9A96A] text-[#1b2a41] px-8 py-3 uppercase tracking-widest text-sm font-semibold hover:bg-white transition-colors duration-300"
              >
                Shop Touche Cosmetics
              </a>
              <a
                href="#contact"
                data-testid="touche-collab-contact-btn"
                className="inline-block border border-[#C9A96A] text-[#C9A96A] px-8 py-3 uppercase tracking-widest text-sm hover:bg-[#C9A96A] hover:text-[#1b2a41] transition-colors duration-300"
              >
                Inquire Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToucheCollab;
